import { render, staticRenderFns } from "./ModalHeader2.vue?vue&type=template&id=3acdf56d&scoped=true"
import script from "./ModalHeader2.vue?vue&type=script&lang=js"
export * from "./ModalHeader2.vue?vue&type=script&lang=js"
import style0 from "./ModalHeader2.vue?vue&type=style&index=0&id=3acdf56d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3acdf56d",
  null
  
)

export default component.exports